// extracted by mini-css-extract-plugin
export default {"root":"MultipleModalAdditionalContent_root__ffenX","placeHolderShimmer":"MultipleModalAdditionalContent_placeHolderShimmer__VwchF"};